import React, { useRef } from "react";
import { Button } from "primereact/button";
import { getSocket } from '../context/socket'; // adjust the path if needed
import { useAuth } from "../context/AuthContext";
import CustomToast from "./CustomToast";
const DuplicateTaskPopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId }) => {
    const { userId } = useAuth();
    const socket = getSocket();
    const toastRef = useRef(null);

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };


    const handleDuplicate = () => {
        if (!cardDetails || cardDetails.task_type !== 'Normal') {
            showMessage('error', "Only tasks of type 'Normal' can be duplicated.");
            return;
        }

        socket.emit("duplicateCard", {
            originalCardId: cardId,
            board_id: boardId,
            userId,
        });

        togglePopup("copy"); // Close popup
    };

    return (
        <div className="popup-box popup-copy">
            <div className="popup-header">
                Duplicate Task
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("copy")} />
            </div>
            <div className="popup-body">
                <div className="list-EmpLIst">

                    <p>
                        Are you sure you want to duplicate this task{' '}
                        <br/>
                        <strong>{cardDetails?.title}</strong>?
                    </p>
                    <div className="d-flex justify-content-end mt-3">
                        <Button
                            label="Cancel"
                            severity="danger"
                            outlined
                            className="border-0 py-1 px-3 me-2"
                            onClick={onCancel}
                        />
                        <Button
                            label="Duplicate Task"
                            severity="success"
                            outlined
                            className="border-0 py-1 px-3"
                            onClick={handleDuplicate}
                        />
                    </div>
                </div>
            </div>
            <CustomToast ref={toastRef} />
        </div>
    );
};

export default DuplicateTaskPopup
